
export const WORKFLOW_API_NAME = "medispend-workflow-api";
export const CFF_API_NAME = "medispend-cff-api";
export const BR_API_NAME = "medispend-br-api";

export const EM_STORAGE_KEY = "em_version";
export const WF_STORAGE_KEY = "wf_version";
export const CFF_STORAGE_KEY = "cff_version";
export const BR_STORAGE_KEY = "br_version";
